// extracted by mini-css-extract-plugin
export default {"operation-panel-tool":"index_operation-panel-tool__Cf+iI"};